// (function () {
// 	const initSlider = () => {
// 		const sliders = document.querySelectorAll(".product-card-js");

// 		sliders.forEach((slider, index) => {
// 			const productSlider = new Swiper(slider, {
// 				pagination: {
// 					el: ".product-pagination .swiper-pagination",
// 					clickable: true,
// 				},
// 				navigation: {
// 					nextEl: ".product-button-group .swiper-button-next",
// 					prevEl: ".product-button-group .swiper-button-prev",
// 				},
// 				allowTouchMove: true,
// 				990: {
// 					allowTouchMove: false,
// 				},
// 			});
// 		});
// 	};

// 	initSlider();

// 	document.addEventListener("shopify:section:load", function () {
// 		initSlider();
// 	});
// })();

  (function () {
	const initSlider = () => {
	  const sliders = document.querySelectorAll(".product-card-js");
  
	  sliders.forEach((slider, index) => {
		const productSlider = new Swiper(slider, {
		  pagination: {
			el: ".product-pagination .swiper-pagination",
			clickable: true,
		  },
		  navigation: {
			nextEl: ".product-button-group .swiper-button-next",
			prevEl: ".product-button-group .swiper-button-prev",
		  },
		  allowTouchMove: true,
		  990: {
			allowTouchMove: false,
		  },
		  on: {
			// init: function () {
			//   const progressBar = slider.querySelector(".swiper-progressbar");
			//   const slidesCount = this.slides.length;
			//   const initialWidth = (1 / slidesCount) * 100 + "%";
			//   progressBar.style.width = initialWidth;
			// },
			// slideChange: function () {
			//   const progressBar = slider.querySelector(".swiper-progressbar");
			//   const activeIndex = this.realIndex;
			//   const slidesCount = this.slides.length;
			//   const progress = (activeIndex + 1) / slidesCount;
			//   progressBar.style.width = `${progress * 100}%`;
			// },
		  },
		});
	  });
	};
  
	initSlider();
  
	document.addEventListener("shopify:section:load", function () {
	  initSlider();
	});
  })();
  
